import HeaderSearchForm from './header-search-form';

const selectors = {
  inputSearch: 'input[type="search"]',
};

class MainSearch extends HeaderSearchForm {
  constructor() {
    super();

    this.allSearchInputs = document.querySelectorAll(selectors.inputSearch);
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    this.input.value = '';
    this.toggleResetButton();
    event.target.querySelector(selectors.inputSearch).focus();
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    if (window.theme.isMobile()) {
      this.scrollIntoView({behavior: 'smooth'});
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

if (!customElements.get('main-search')) {
  customElements.define('main-search', MainSearch);
}
